module.exports = __webpack_public_path__ + "img/13-1.31f30af1.png";